import React from 'react';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { themeUtils } from '../../../theme';

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'chipVariant',
})(({ theme, chipVariant }) => {
  const variants = {
    default: {
      borderRadius: theme.spacing(1),
      fontWeight: 500,
    },
    status: {
      borderRadius: theme.spacing(1),
      fontWeight: 600,
      fontSize: '0.75rem',
      height: 24,
      '&.MuiChip-colorPrimary': {
        backgroundColor: themeUtils.colors.blue['blue-100'],
        color: themeUtils.colors.blue['blue-700'],
      },
      '&.MuiChip-colorSuccess': {
        backgroundColor: themeUtils.colors.blue['blue-100'],
        color: themeUtils.colors.blue['blue-700'],
      },
      '&.MuiChip-colorError': {
        backgroundColor: theme.palette.error[100],
        color: theme.palette.error.dark,
      },
      '&.MuiChip-colorWarning': {
        backgroundColor: theme.palette.warning[100],
        color: theme.palette.warning.dark,
      },
    },
    currency: {
      borderRadius: theme.spacing(2),
      fontWeight: 600,
      fontSize: '0.8rem',
      backgroundColor: theme.palette.secondary[100] || theme.palette.secondary.light,
      color: theme.palette.secondary.dark,
      border: `1px solid ${theme.palette.secondary[300] || theme.palette.secondary.main}`,
    },
    filter: {
      borderRadius: theme.spacing(1.5),
      fontWeight: 500,
      fontSize: '0.875rem',
      backgroundColor: theme.palette.primary[50],
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary[200]}`,
      '&:hover': {
        backgroundColor: theme.palette.primary[100],
      },
      '& .MuiChip-deleteIcon': {
        color: theme.palette.primary.main,
        '&:hover': {
          color: theme.palette.primary.dark,
        },
      },
    },
    action: {
      borderRadius: 0,
      fontWeight: 500,
      transition: 'all 0.2s ease',
      '&:hover': {
        transform: 'translateY(-1px)',
        boxShadow: `0 2px 8px ${theme.palette.primary.main}20`,
      },
    },
  };

  return variants[chipVariant] || variants.default;
});

const EasyCheckChip = ({
  children,
  variant = 'default',
  color = 'default',
  size = 'medium',
  ...props
}) => {
  return (
    <StyledChip
      label={children}
      chipVariant={variant}
      color={color}
      size={size}
      {...props}
    />
  );
};

EasyCheckChip.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'status', 'currency', 'filter', 'action']),
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'success', 'error', 'warning', 'info']),
  size: PropTypes.oneOf(['small', 'medium']),
};

export default EasyCheckChip; 